<template>
  <div class="customer-details-sidebar">
    <!-- Consultant, Date created, Country, Currency -->
    <div class="detail-container">
      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.consultant").toUpperCase() }}:</span>
        <span class="detail-value">{{ (customer.agent && customer.agent.full_name) || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.date_created").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.created_at ? customer.created_at.substring(0, 10) : '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.country").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.company_country || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.currency").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.currency || '-' }}</span>
      </div>
    </div>

    <!-- Category, Source -->
    <div class="detail-container">
      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.category").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.category || '-' }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">{{ $t("globals.source").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.source || '-' }}</span>
      </div>
    </div>

    <!-- WebApp registration -->
    <div v-if="customer.web_app_id" class="detail-container">
      <div
        v-if="!customer.webapp_registration_sent_at && !customer.webapp_registration_accepted_at"
        class="detail-item"
      >
        <span class="detail-label">{{ $t("globals.webapp_registration").toUpperCase() }}:</span>
        <span class="detail-value">-</span>
      </div>

      <div v-if="customer.webapp_registration_sent_at" class="detail-item">
        <span class="detail-label">{{ $t("globals.sent_at").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.webapp_registration_sent_at.substring(0, 10) }}</span>
      </div>

      <div v-if="customer.webapp_registration_accepted_at" class="detail-item">
        <span class="detail-label">{{ $t("globals.accepted_at").toUpperCase() }}:</span>
        <span class="detail-value">{{ customer.webapp_registration_accepted_at.substring(0, 10) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.customer-details-sidebar {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
}

.detail-container:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-label {
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
  line-height: 1.4;
  word-break: break-word;
}

@media (max-width: 768px) {
  .customer-details-sidebar {
    gap: 20px;
  }

  .detail-container {
    gap: 12px;
    padding-bottom: 20px;
  }

  .detail-item {
    gap: 6px;
  }
}
</style>
